export default __webpack_public_path__ + "static/celestar_screenshot-e7ede8dd70a68fcc95631e9f2191f46f.webp";